var _svg;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This file is automatically generated from generateIcons.js
import * as React from 'react';
import IconContainer from '../IconContainer.js';

function TooltipIcon(props) {
  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 22 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11S17.075 0 11 0zm1.571 15.714a1.572 1.572 0 01-3.142 0V11a1.572 1.572 0 013.142 0v4.714zM11 7.857a1.572 1.572 0 11.001-3.144A1.572 1.572 0 0111 7.857z",
      fill: "currentColor"
    })))
  }));
}

export default TooltipIcon;